import styled from 'styled-components';

export const SidebarOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100005;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
`;

export const SidebarContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100006;
  height: 100%;
  width: 92vw;
  max-width: 420px;
  transform: ${(p) => (p.$open ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease;
`;

export const SidebarPanel = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  background: transparent;
  box-shadow: 0 40px 120px rgba(0, 0, 0, 0.75);
  outline: none;
`;

export const NeonGlow = styled.div`
  pointer-events: none;
  position: absolute;
  inset: -48px;
  opacity: 0.4;
  filter: blur(32px);
  &::before {
    content: '';
    position: absolute;
    left: 24px;
    top: 40px;
    width: 224px;
    height: 224px;
    border-radius: 50%;
    background: rgba(6, 182, 212, 0.3);
  }
  &::after {
    content: '';
    position: absolute;
    right: 32px;
    top: 96px;
    width: 256px;
    height: 256px;
    border-radius: 50%;
    background: rgba(139, 92, 246, 0.25);
  }
`;

export const SidebarHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  padding: 16px;
  backdrop-filter: blur(12px);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const WalletIconContainer = styled.div`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
`;

export const HeaderTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #e5e7eb;
`;

export const HeaderSubtitle = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 8px;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
`;

export const SidebarBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100% - 72px);
  overflow-y: auto;
  padding: 16px;
`;

export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.4);
`;

export const BalanceCard = styled.div`
  border-radius: 16px;
  border: 1px solid ${(p) => (p.$expanded ? 'rgba(34, 211, 238, 0.4)' : 'rgba(255, 255, 255, 0.1)')};
  background: rgba(255, 255, 255, 0.03);
  padding: 12px;
  margin-top: 12px;
  box-shadow: ${(p) => (p.$expanded ? '0 0 0 1px rgba(34,211,238,0.35), 0 0 40px rgba(34,211,238,0.2)' : 'none')};
`;

export const BalanceCardHeader = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  text-align: left;
`;

export const BalanceCardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const WalletIconBox = styled.div`
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
`;

export const PrimaryPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(to right, rgba(6, 182, 212, 0.15), rgba(139, 92, 246, 0.1));
  padding: 8px 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const BankModeButton = styled.button`
  flex: 1;
  border-radius: 12px;
  border: 1px solid ${(p) => (p.$active ? 'rgba(34, 211, 238, 0.4)' : 'rgba(255, 255, 255, 0.1)')};
  background: ${(p) => (p.$active ? 'rgba(6, 182, 212, 0.1)' : 'rgba(255, 255, 255, 0.05)')};
  color: ${(p) => (p.$active ? '#67e8f9' : 'rgba(255, 255, 255, 0.7)')};
  padding: 8px 12px;
  font-size: 12px;
  cursor: pointer;
`;

export const BankDetailBox = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
  padding: 12px;
  font-size: 12px;
  margin-top: 12px;
`;

export const LongPressBtn = styled.button`
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  background: ${(p) => (p.disabled ? 'rgba(255, 255, 255, 0.05)' : 'linear-gradient(to right, rgba(6, 182, 212, 0.15), rgba(139, 92, 246, 0.1))')};
  color: ${(p) => (p.disabled ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.9)')};
  &:hover:not(:disabled) {
    border-color: rgba(255, 255, 255, 0.2);
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.1), transparent);
  margin: 16px 0;
`;

export const SidebarFooter = styled.div`
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const FooterText = styled.div`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  margin-top: 8px;
`;

/* Step indicator (multi-step flow) */
export const StepIndicatorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
`;

export const StepTrack = styled.div`
  flex: 1;
  height: 2px;
  background: ${(p) => (p.$active ? 'rgba(34, 211, 238, 0.5)' : 'rgba(255,255,255,0.1)')};
  border-radius: 1px;
  position: relative;
`;

export const StepDot = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${(p) => (p.$active ? '#22d3ee' : 'rgba(255,255,255,0.1)')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: ${(p) => (p.$active ? '#0b0e14' : 'rgba(255,255,255,0.4)')};
`;

export const StepLabel = styled.div`
  font-size: 11px;
  color: rgba(255,255,255,0.5);
  min-width: 70px;
  text-align: center;
`;

/* Form / content blocks */
export const StepContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 12px;
  color: rgba(255,255,255,0.7);
  margin-bottom: 6px;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  &:focus {
    border-color: rgba(34, 211, 238, 0.5);
  }
  &::placeholder {
    color: rgba(255,255,255,0.5);
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  color: #fff;
  font-size: 14px;
  outline: none;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.2s;
  &:focus {
    border-color: rgba(34, 211, 238, 0.5);
  }
  &::placeholder {
    color: rgba(255,255,255,0.5);
  }
`;

export const FormHint = styled.div`
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  margin-top: -8px;
  margin-bottom: 8px;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s;
  background: ${(p) =>
    p.disabled ? 'rgba(255,255,255,0.1)' : 'linear-gradient(135deg, #22d3ee 0%, #06b6d4 100%)'};
  color: ${(p) => (p.disabled ? 'rgba(255,255,255,0.3)' : '#0b0e14')};
`;

/* Order overview / summary */
export const OrderSummaryBox = styled.div`
  margin-top: 8px;
  padding: 16px;
  border-radius: 12px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
`;

export const SummaryLabel = styled.span`
  color: rgba(255,255,255,0.7);
`;

export const SummaryValue = styled.span`
  font-weight: 500;
  color: rgba(255,255,255,0.9);
`;

export const SummaryTotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid rgba(255,255,255,0.1);
`;

export const SummaryTotal = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #67e8f9;
`;

export const BalanceCheckSection = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255,255,255,0.1);
`;

export const BalanceMessage = styled.div`
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  margin-top: 8px;
  background: ${(p) => (p.$error ? 'rgba(251, 113, 133, 0.1)' : p.$success ? 'rgba(16, 185, 129, 0.1)' : 'transparent')};
  border: 1px solid ${(p) => (p.$error ? 'rgba(251, 113, 133, 0.3)' : p.$success ? 'rgba(16, 185, 129, 0.3)' : 'transparent')};
  color: ${(p) => (p.$error ? '#fb7185' : p.$success ? '#6ee7b7' : 'inherit')};
`;

export const CartItemsScroll = styled.div`
  max-height: 400px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 4px;
`;

export const CartItemCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  padding: 12px;
  border-radius: 12px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.1);
`;

export const CartItemName = styled.div`
  font-size: 14px;
  color: rgba(255,255,255,0.9);
  margin-bottom: 4px;
`;

export const CartItemMeta = styled.div`
  font-size: 12px;
  color: rgba(255,255,255,0.5);
`;

export const CartItemPrice = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #67e8f9;
  margin-left: 16px;
`;

export const EmptyCartMessage = styled.div`
  padding: 24px;
  text-align: center;
  color: rgba(255,255,255,0.5);
  font-size: 14px;
`;

export const SectionHint = styled.div`
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  margin-top: 4px;
  margin-bottom: 12px;
`;

export const BackButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.8);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: rgba(255,255,255,0.1);
  }
`;

export const FooterActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
`;

export const LoadingBalancesMessage = styled.div`
  padding: 24px;
  text-align: center;
  color: rgba(255,255,255,0.6);
  font-size: 14px;
`;
